export default __webpack_public_path__ + "static/media/bg-landing-subheader.6c30df03.jpg";